module.exports = __webpack_public_path__ + "static/media/3_audience_hall_rear.4ec64951.jpg";